import { useLocation, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { getAuthCookie } from "../../utils/authCookies";
// import "react-toastify/dist/ReactToastify.css";

type PaymentGateway = {
  id: string;
  name: string;
  gateway: string;
  api_key: string;
  secret_key: string;
  publishable_key: string;
  status: boolean;
};

const SignageViewPaymentGateway = () => {
  const { gatewayId } = useParams<{ gatewayId: string }>();
  const token = getAuthCookie("sessionToken");
  const [paymentGateway, setPaymentGateway] = useState<PaymentGateway | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>("");
  const navigate = useNavigate();

  const location = useLocation();
  useEffect(() => {
    if (location.state?.successMessage) {
      toast.success(location.state.successMessage);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchPaymentGatewayData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/payments/gateway/${gatewayId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setPaymentGateway(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (gatewayId) {
      fetchPaymentGatewayData();
    }
  }, [gatewayId, token]);

  return (
    <div className="content">
      <h3 className="text-center table-headers">Payment Gateway Information</h3>

      <div className="row justify-content-center">
        <div className="col-md-10 col-lg-10 col-xl-8">
          <div className=" shadow-sm">
            <table className="table table-bordered align-middle">
              <tbody>
                <tr className="table-light">
                  <th className='text-center table-headers' style={{ width: "35%" }}>Name</th>
                  <td className='table-cells'>{paymentGateway?.name || '—'}</td>
                </tr>
                <tr>
                  <th className='text-center table-headers'>Gateway</th>
                  <td className='table-cells'>{paymentGateway?.gateway || '—'}</td>
                </tr>
                <tr>
                  <th className='text-center table-headers'>API Key</th>
                  <td className='table-cells'>{paymentGateway?.api_key || '—'}</td>
                </tr>
                <tr>
                  <th className='text-center table-headers'>Secret Key</th>
                  <td className='table-cells'>{paymentGateway?.secret_key || '—'}</td>
                </tr>
                <tr>
                  <th className='text-center table-headers'>Publishable Key</th>
                  <td className='table-cells'>{paymentGateway?.publishable_key || '—'}</td>
                </tr>
                <tr>
                  <th className='text-center table-headers'>Status</th>
                  {/* <td className='table-cells'>
                      {paymentGateway?.status === "Inactive" ? (
                        <span className="badge bg-danger">Inactive</span>
                      ) : (
                        <span className="badge bg-success">Active</span>
                      )}
                    </td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  );
};

export default SignageViewPaymentGateway;
